import React, { memo, useMemo } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { IconButton, Tooltip, Stack, Icon, Typography } from 'investira.react.components';
import { validators } from 'investira.sdk';
import { BulkContextActions, DataTable } from '../../../../components/organisms';
import withAvaliacoesSessoes from '../../../../hoc/withAvaliacoesSessoes';
const SecoesSettings = memo(props => {
  const {
    sessoes = [],
    enquadramentos,
    state,
    columns,
    renderDetailPanel,
    onBulkDeleteClick,
    ...restProps
  } = props;
  const navigate = useNavigate();
  const location = useLocation();
  const xColumns = useMemo(() => {
    return [{
      id: 'avaliacao_secao',
      accessorKey: 'avaliacao_secao',
      header: 'Sessão',
      enableColumnActions: false,
      enableSorting: false,
      //size: 10000,

      Cell: ({
        cell
      }) => {
        if (validators.isNull(cell.getValue())) {
          return null;
        }
        return cell.getValue();
      }
    }, {
      id: 'avaliacao_secao_sigla',
      accessorKey: 'avaliacao_secao_sigla',
      header: 'Sessão Alias',
      enableColumnActions: false,
      enableSorting: false,
      //size: 10000,

      Cell: ({
        cell
      }) => {
        if (validators.isNull(cell.getValue())) {
          return null;
        }
        return cell.getValue();
      }
    }, {
      id: 'avaliacao_secao_descricao',
      accessorKey: 'avaliacao_secao_descricao',
      header: 'Descrição',
      enableColumnActions: false,
      enableSorting: false,
      //size: 10000,
      muiTableHeadCellProps: {
        sx: {
          width: '100% !important'
        }
      },
      Cell: ({
        cell
      }) => {
        if (validators.isNull(cell.getValue())) {
          return null;
        }
        return <Typography variant="caption" color="textPrimary">
              {cell.getValue()}
            </Typography>;
      }
    }];
  }, []);
  const xProps = {
    columns: xColumns,
    data: sessoes,
    readData: props.readSessoes,
    isLoading: Boolean(props.isLoading),
    initialState: {
      pagination: props.pagination || {
        pageIndex: 0,
        pageSize: 25
      },
      columnVisibility: {
        carteira: false
      },
      columnSizing: {
        // Define larguras fixas para as colunas de seleção e ações
        'mrt-row-select': 50,
        // Largura fixa para a coluna de seleção
        'mrt-row-actions': 80 // Largura fixa para a coluna de ações
      },
      density: 'comfortable'
    },
    manualFiltering: true,
    manualSorting: true,
    manualPagination: true,
    getRowId: row => row.log_id,
    state: {
      isLoading: Boolean(props.isLoading),
      pagination: props.pagination || {
        pageIndex: 0,
        pageSize: 25
      },
      showProgressBars: props.isRefetching,
      columnFilters: props.columnFilters || [],
      sorting: props.sorting || [],
      rowSelection: props.rowSelection || {}
    },
    rowCount: props.rowCount || 0,
    onColumnFiltersChange: props.setColumnFilters,
    onSortingChange: props.setSorting,
    onPaginationChange: props.setPagination,
    onRowSelectionChange: props.setRowSelection,
    onGlobalFilterChange: props.setGlobalFilter,
    //onBulkDeleteClick: props.bulkDeleteLogs,
    enableRowSelection: true,
    renderTopToolbarCustomActions: ({
      table
    }) => {
      const selectedRows = table.getSelectedRowModel().rows;
      const isSomeRowSelected = selectedRows.length > 0;
      return <BulkContextActions onDeleteClick={() => {
        props.bulkDeleteSessoes(selectedRows);
      }} disabled={props.isLoading || props.isRefetching || !isSomeRowSelected} />;
    },
    muiTableContainerProps: {
      sx: {
        maxWidth: '100%' // Garante que a tabela ocupe 100% do espaço disponível
      }
    },
    displayColumnDefOptions: {
      'mrt-row-actions': {
        size: 80 // largura em pixels para a coluna de ações
      },
      'mrt-row-select': {
        size: 50 // largura em pixels para a coluna de seleção
      }
    },
    renderRowActions: ({
      row
    }) => {
      return <Stack direction="row" spacing={1}>
          <Tooltip title="Editar">
            <span>
              <IconButton color="primary" onClick={() => navigate(`${location.pathname}/edit/${row.original.avaliacao_secao_id}`, {
              state: row.original
            })}>
                <Icon iconName="edit" size={18} />
              </IconButton>
            </span>
          </Tooltip>
        </Stack>;
    },
    ...restProps
  };
  return <DataTable {...xProps} />;
});
SecoesSettings.displayName = 'SecoesSettings';
export default withAvaliacoesSessoes(SecoesSettings);
